import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.app-filter-without-order {
  display: flex;
  flex-direction: row;
  align-items: center;

  & .label-container {
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;
  }

  & .checkbox-container {
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 0.5rem;
    min-height: calc(${dt('form.field.sm.font.lineHeight')} + (${dt('form.field.sm.padding.y')} * 2));
  }

  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    & .checkbox-container {
      min-height: calc(${dt('form.field.md.font.lineHeight')} + (${dt('form.field.md.padding.y')} * 2));
    }
  }

  @media screen and (min-width: 1920px) {
    & .checkbox-container {
      min-height: calc(${dt('form.field.lg.font.lineHeight')} + (${dt('form.field.lg.padding.y')} * 2));
    }
  }
}`;
